import type {
  DresonResolvedData,
  FacetValueTagsLoadedData,
} from "./types/global";
import { trackingStore } from "./store/TrackingStore";
import { tlSearchBoxActionCharacter } from "./tracking/labels/SearchBoxAction";
import { searchfieldStore, value } from "./store/SearchfieldStore";
import { submitHistory } from "./store/HistoryStore";
import { navSlider } from "./components/suggestLayer/navSlider/NavSlider";
import { sqrlRequest } from "./util/SqrlRequest";
import { get } from "svelte/store";
import { sqrlConsentBanner } from "./util/SqrlConsentBanner";
import { onSearchFocus } from "./index.js";

export class SearchHandler {
  /**
 *
 *
 *
 *
 */
  fetchSearchTerm() {
    const searchterm = document
      .querySelector("#reptile-searchterm")
      ?.getAttribute("data-searchterm");
    if (searchterm) {
      trackingStore.$sendTrackingLabelOnFocus = false;
      tlSearchBoxActionCharacter.setIsTrackable(false);
      searchfieldStore.$value = searchterm;
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  enableEventFilterListener() {
    window.o_global
      .events()
      .on(
        "ftfind.dresonRule.resolved",
        ({ rule, redirect }: DresonResolvedData) =>
          submitHistory.updateTarget(rule, redirect),
      );

    otto.heureka.facetValueTags_loaded.sub(
      ({ rule, tags }: FacetValueTagsLoadedData) => {
        submitHistory.updateTags(rule, tags);
      },
    );
  }

  initNavSlider() {
    onSearchFocus.sub(navSlider.onMergeEventContext);
  }

  async init() {
    this.fetchSearchTerm();
    await sqrlConsentBanner.update().finally(() => {
      sqrlConsentBanner.listenOnConsentChange();
      submitHistory.reInitialize();
      sqrlRequest.fetch(get(value), get(value).length, true);
    });
    this.enableEventFilterListener();
    this.initNavSlider();
  }
}

export const searchHandler = new SearchHandler();
